import { HEADER_FEATURE_TYPES } from './constants';
import Mission from '../components/Mission';
import Reviewer from '../components/Reviewer';
import Highlights from '../components/Highlights';

export const HEADER_FEATURE_TYPE_TO_COMPONENT = {
  [HEADER_FEATURE_TYPES.MISSION]: Mission,
  [HEADER_FEATURE_TYPES.HIGHLIGHTS]: Highlights,
  [HEADER_FEATURE_TYPES.REVIEWER]: Reviewer,
  [HEADER_FEATURE_TYPES.BREEDER_MISSION]: Mission
};
